import { isFuture, isPast, getDueDateDiffInHours } from '../../../utils/dateUtlis';

export const DISCUSSION_STATE_COLOR = {
  inProgress: '#4ea05c',
  dueSoon: '#ffae4d',
  closed: '#F05060',
  scheduled: '#eac52d'
};

export const DISCUSSION_DUE_SOON_TEXT_COLOR = '#9a5b00';

// Same window the due-date badge already used: due within the next 24h, not yet past.
export const isDueSoon = dueDate => {
  const differenceInHours = getDueDateDiffInHours(dueDate);
  return differenceInHours >= 0 && differenceInHours <= 24;
};

export const getDiscussionAccentColor = discussion => {
  const isClassroomDiscussion = !discussion.activityContext;

  if (!isClassroomDiscussion) {
    // Content discussions have no dueDate, so they can only ever be "in progress".
    return DISCUSSION_STATE_COLOR.inProgress;
  }
  if (isFuture(discussion.startDate)) {
    return DISCUSSION_STATE_COLOR.scheduled;
  }
  if (isPast(discussion.dueDate)) {
    return DISCUSSION_STATE_COLOR.closed;
  }
  if (isDueSoon(discussion.dueDate)) {
    return DISCUSSION_STATE_COLOR.dueSoon;
  }
  return DISCUSSION_STATE_COLOR.inProgress;
};
